/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OrganizationFeatureResource = {
    id: number
    name: string
    display_name: string
    description: string
    status: OrganizationFeatureResource.status
    organization_status: boolean | null
    /**
     * Why the organization-level toggle was last set. Only meaningful when disabled.
     */
    organization_status_reason?: string | null
    user_statuses?: Record<string, boolean>
    integration_id?: number | null
}

export namespace OrganizationFeatureResource {
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
        '_6' = 6
    }
}
